// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__O2zT6","sound_wave":"Loader_sound_wave__aS9UW","audio-wave":"Loader_audio-wave__PgCHS"};